export default __webpack_public_path__ + "static/avatar-success-d3b5f3288a3472183efff8791a140854.png";